module.exports = __webpack_public_path__ + "2b436d03147344af38112d91bf784438.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/771.png
// module id = 1695
// module chunks = 2